import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import QrScanner from './components/qrScanner';
import QrCodeGenerator from './components/qrCodeGenerator';
import MemberData from './pages/memberData';
import MemberSignIn from './pages/memberSignIn';
import HomePage from './pages/home';
import './css/style.css';
import LoginAdmin from './pages/loginAdmin';

//import { QrcodeResultFormat } from 'html5-qrcode/esm/core';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/memberSignIn" element={<MemberSignIn />} />
                <Route path="/memberData" element={<MemberData />} />
                <Route path="/loginAdmin" element={<LoginAdmin />} />
                <Route path="/qrScanner" element={<QrScanner />} />
                <Route path="/qrCodeGenerator" element={<QrCodeGenerator />} />
            </Routes>
        </Router>        
    );
};

export default App;
